import axios from "axios";
import React, { useState } from "react";
import swal from "sweetalert";
import { Modalprogress } from "../Modal/Modalprogress";
import { Modalsuccessfile } from "../Modal/Modalsuccessfile";
const { REACT_APP_API_URL } = process.env;

const RevokeInput = () => {
  const [successModal, setSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [identifier, setIdentifier] = useState();
  const updateDoc = async () => {
    setLoading(true);
    if (identifier) {
      try {
        const response = await axios.post(
          `${REACT_APP_API_URL}/doc-hash/revoke`,
          { identifier: identifier },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${process.env.CLIENT_TOKEN}`,
            },
            validateStatus: (status) => status < 500,
          }
        );
        if (response.status === 200) {
          setLoading(false);
          setIdentifier("");
          setSuccessModal(true);
        } else if (response.status === 400) {
          setLoading(false);
          swal({
            title: "Unable to revoke",
            text: response.data.err || "An error occurred",
            icon: "error",
          });
        } else {
          setLoading(false);
          swal({
            title: "Unable to revoke",
            text: response.data.error || "An unknown error occurred",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error updating document:", error);
      }
    } else {
      swal({
        title: "Please enter the identifier",
        text: "Please enter a valid identifier",
        icon: "error",
      });
    }
  };
  return (
    <>
      <Modalprogress
        loading={loading}
        msg={[
          "Looking for digest on the chain..",
          "Revoking digest from chain...",
        ]}
      />
      <Modalsuccessfile
        loading={successModal}
        msg={"Revoked Successfully"}
        txtmsg={
          "Document successfully revoked on  weavenet.cord.network chain."
        }
        Identifier={undefined}
        blockhash={undefined}
        onClose={() => {
          setSuccessModal(false);
        }}
      />
      <div className="col-md-12">
        <p className=" mt-3 fw-bolder">Enter the Identifier</p>
        <div className="input-wrapper">
          <input
            type="text"
            name="text"
            className="input"
            placeholder="Identifier"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
          />
          <button
            className="update-btn "
            disabled={identifier && identifier.length > 1 ? false : true}
            onClick={() => {
              updateDoc();
            }}
          >
            Revoke
          </button>
        </div>
      </div>
    </>
  );
};

export default RevokeInput;
